import "./plugins.js"

class App {

    constructor() {
        jQuery(document).ready(($) => {
            this.onDomReady($);
        });
        jQuery.extend(true, jQuery.datePicker.defaults, {
            strings: {
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            },
            dateFormat: function(date) {
                return $.datePicker.defaults.pad(date.getDate(), 2) + '/' + $.datePicker.defaults.pad(date.getMonth() + 1, 2) + '/' + date.getFullYear();
            },
            dateParse: function(string) {
                var date = new Date();
                if (string instanceof Date) {
                    date = new Date(string);
                } else {
                    var parts = string.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
                    if ( parts && parts.length == 4 ) {
                        date = new Date( parts[3], parts[2] - 1, parts[1] );
                    }
                }
                return date;
            }
        });

        jQuery.extend(true, jQuery.alert.defaults, {
            templates: {
              button: '<a href="#" class="btn btn-primary"></a>'
            }
        });

        document.addEventListener('alpine:init', () => {
            Alpine.data('division', () => ({
                words: 0,
                color: 'text-success',
                icon: 'fa-solid fa-circle-check me-1',
                options: {
                    'Arquitectura de Comunicación': {
                        items: [
                            'Estrategias Integradas de Comunicación',
                            'Estrategias de Comunicación Interna y Cultura',
                            'Estrategias de Comunicación Externa y Reputación'
                        ],
                        labels: {
                            'necesidad': '<strong>¿A qué necesidad u oportunidad de negocio u organización responde el proyecto de comunicación?</strong><br>Describe claramente los aspectos que la organización tuvo que enfrentar, planteando el impacto que este aspecto tiene sobre el comportamiento, reputación, utilidades, participación de mercado, etcétera.<br>Destaca cualquier descubrimiento de la investigación que, de manera formal o informal, haya dado soporte al análisis de la necesidad u oportunidad.',
                            'publicos_objetivo': '<strong>Identificación de los públicos objetivo</strong><br>Describe tus públicos clave y especifica qué características de tu audiencia primaria fueron factores esenciales para desarrollar la solución: perfil sociodemográfico, estilo de vida, edad, sexo, ubicación geográfica, y en general, la descripción exhaustiva de los públicos meta.<br>Menciona la investigación realizada para sustentar este punto. La descripción de públicos objetivo sirve para ver qué tanto conoces a tu audiencia, ya que eso es fundamental para cualquier intervención en materia de comunicación.<br>Además, una correcta descripción demuestra mayor profesionalismo porque aportas evidencia de que no has inventado la solución. Esto aumenta tu probabilidad de éxito en la ejecución de la comunicación y, por consiguiente, en el Premio AMCO. Por ejemplo, si la mayoría del personal de una empresa son jóvenes entre los 20-25 años, el tono de la comunicación debe ser muy diferente al utilizado para llegar al público ubicado en el rango de los 40 años en adelante. Lo que se busca con este apartado es comprender cómo has utilizado la información disponible sobre los públicos y qué decisiones has tomado con ella.',
                            'meta_general': '<strong>Objetivos/metas (General y específicos)</strong><br>Para satisfacer la necesidad/oportunidad, ¿qué metas de comunicación y objetivos estableciste y cómo se relacionaron con los objetivos estratégicos del negocio? Deben ser reales y medibles por resultados, tales como cantidad, tiempo, costo, porcentajes, calidad o algún otro criterio, cuantitativo o cualitativo, debidamente documentado. Se toma en cuenta en particular que se hayan definido objetivos medibles.<br>General',
                            'vision': '<strong>Visión general de la solución</strong><br>¿Qué solución desarrollaste y por qué? Resume el proyecto, programa o campaña y describe el fundamento racional o la solución creativa de tu propuesta/programa. La solución debe demostrar tu forma racional y creativa para afrontar la necesidad/oportunidad.<br>Identifica tus mensajes claves. Detalla los retos de implantación.<br>Menciona el presupuesto de tu proyecto o retorno de inversión (porcentaje) demuestra las eficiencias en el uso de recursos. Presenta el cronograma de trabajo.<br>Describe cualquier limitación o reto que debiste enfrentar para vender, presentar e implementar tu proyecto (incluye presupuesto, tiempo, equipo técnico y otros recursos).',
                            'muestra': '<strong>Muestra (descripción)</strong> <br>Presenta las tácticas de comunicación utilizadas. <br>Describe las características y motivos del porqué los materiales empleados: las ejecuciones tácticas, medios, materiales, testigos de las actividades llevadas a cabo. <br>En este apartado lo que se valora no es la descripción que escribas en el resumen ejecutivo, sino la muestra en sí (que será un archivo ZIP independiente, el cual podrás cargar mas abajo).',
                            'medicion': '<strong>Medición/evaluación de resultados</strong> <br>La medición del proyecto está estrechamente ligada con los objetivos planteados. ¿Cómo mediste el éxito del proyecto, cómo se demuestra que cumpliste – y en qué nivel – con tus objetivos? La medición debe demostrar resultados exitosos; puede ser cuantitativa o cualitativa y debe estar relacionada con los resultados, no con la ejecución. <br>Por ejemplo, si tu campaña de relación con medios apoyaba el lanzamiento de un producto, tus mediciones deben ceñirse a los objetivos de ventas u otras medidas fundamentales, no a la cantidad de recortes o menciones en prensa u otras medidas propias de la ejecución. <br>Si tu reto era mejorar la comprensión de los empleados sobre un evento o mensaje importante, debes mostrar que su conocimiento aumentó, al menos en parte, como resultado del plan de comunicación que implantaste.',
                        }
                    },
                    'Experiencias de Comunicación': {
                        items: [
                            'Contenido Visual y Narrativas Audiovisuales',
                            'Ecosistemas Digitales y Plataformas',
                            'Experiencias de Marca y Activaciones',
                            'Contenido Editorial y Narrativa Corporativa'
                        ],
                        labels: {
                            'necesidad': '<strong>¿A qué necesidad u oportunidad de negocio u organización responde el proyecto de comunicación?</strong><br>Describe claramente los aspectos que la organización tuvo que enfrentar, planteando el impacto que este aspecto tiene sobre el comportamiento, reputación, utilidades, participación de mercado, etcétera.<br>Destaca cualquier descubrimiento de la investigación que, de manera formal o informal, haya dado soporte al análisis de la necesidad u oportunidad.',
                            'publicos_objetivo': '<strong>Identificación de los públicos objetivo</strong><br>Describe tus públicos clave y especifica qué características de tu audiencia primaria fueron factores esenciales para desarrollar la solución: perfil sociodemográfico, estilo de vida, edad, sexo, ubicación geográfica, y en general, la descripción exhaustiva de los públicos meta.<br>Menciona la investigación realizada para sustentar este punto. La descripción de públicos objetivo sirve para ver qué tanto conoces a tu audiencia, ya que eso es fundamental para cualquier intervención en materia de comunicación.<br>Además, una correcta descripción demuestra mayor profesionalismo porque aportas evidencia de que no has inventado la solución. Esto aumenta tu probabilidad de éxito en la ejecución de la comunicación y, por consiguiente, en el Premio AMCO. Por ejemplo, si la mayoría del personal de una empresa son jóvenes entre los 20-25 años, el tono de la comunicación debe ser muy diferente al utilizado para llegar al público ubicado en el rango de los 40 años en adelante. Lo que se busca con este apartado es comprender cómo has utilizado la información disponible sobre los públicos y qué decisiones has tomado con ella.',
                            'meta_general': '<strong>Objetivos/metas (General y específicos)</strong><br>Para satisfacer la necesidad/oportunidad, ¿qué metas de comunicación y objetivos estableciste y cómo se relacionaron con los objetivos estratégicos del negocio? Deben ser reales y medibles por resultados, tales como cantidad, tiempo, costo, porcentajes, calidad o algún otro criterio, cuantitativo o cualitativo, debidamente documentado. Se toma en cuenta en particular que se hayan definido objetivos medibles.<br>General',
                            'vision': '<strong>Visión general de la solución</strong><br>¿Qué solución desarrollaste y por qué? Resume el proyecto, programa o campaña y describe el fundamento racional o la solución creativa de tu propuesta/programa. La solución debe demostrar tu forma racional y creativa para afrontar la necesidad/oportunidad.<br>Identifica tus mensajes claves. Detalla los retos de implantación.<br>Menciona el presupuesto de tu proyecto o retorno de inversión (porcentaje) demuestra las eficiencias en el uso de recursos. Presenta el cronograma de trabajo.<br>Describe cualquier limitación o reto que debiste enfrentar para vender, presentar e implementar tu proyecto (incluye presupuesto, tiempo, equipo técnico y otros recursos).',
                            'muestra': '<strong>Muestra (descripción)</strong> <br>Presenta las tácticas de comunicación utilizadas. <br>Describe las características y motivos del porqué los materiales empleados: las ejecuciones tácticas, medios, materiales, testigos de las actividades llevadas a cabo. <br>En este apartado lo que se valora no es la descripción que escribas en el resumen ejecutivo, sino la muestra en sí (que será un archivo ZIP independiente, el cual podrás cargar mas abajo).',
                            'medicion': '<strong>Medición/evaluación de resultados</strong> <br>La medición del proyecto está estrechamente ligada con los objetivos planteados. ¿Cómo mediste el éxito del proyecto, cómo se demuestra que cumpliste – y en qué nivel – con tus objetivos? <br>La medición debe demostrar resultados exitosos; puede ser cuantitativa o cualitativa y debe estar relacionada con los resultados, no con la ejecución. <br>Por ejemplo, si tu campaña de relación con medios apoyaba el lanzamiento de un producto, tus mediciones deben ceñirse a los objetivos de ventas u otras medidas fundamentales, no a la cantidad de recortes o menciones en prensa u otras medidas propias de la ejecución. <br>Si tu reto era mejorar la comprensión de los empleados sobre un evento o mensaje importante, debes mostrar que su conocimiento aumentó, al menos en parte, como resultado del plan de comunicación que implantaste.',
                        }
                    },
                    'Evaluación': {
                        items: [
                            'Evaluación'
                        ],
                        labels: {
                            'necesidad': '<strong>¿Por qué era necesario o recomendable establecer una evaluación o medición?</strong><br>Describe claramente las razones por las que se recurre a una evaluación o medición de la situación de comunicación.',
                            'publicos_objetivo': '<strong>Identificación de los públicos objetivo</strong><br>Describe a los públicos involucrados en el estudio y las razones para elegirlos: perfil sociodemográfico, estilo de vida, edad, sexo, ubicación geográfica, y en general, la descripción exhaustiva de los públicos meta. Aclara si la evaluación tiene como propósito conocer mejor e indagar en las características de los públicos objetivos (mapeo de públicos, investigación de mercados para la comunicación).',
                            'meta_general': '<strong>Objetivos/metas (General y específicos)</strong><br>¿Cuáles son los objetivos planteados para la evaluación y por qué? ¿Qué hipótesis de investigación se formularon y qué elementos se tomaron en cuenta para determinarlas?<br>General',
                            'vision': '',
                            'muestra': '<strong>Muestra (descripción)</strong> <br>Presenta cualquier testigo de ejecuciones tácticas que se hayan utilizado para apoyar la evaluación: ¿se hizo una campaña para invitar a la participación? ¿Se difundieron sus propósitos a públicos clave? Describe las características y motivos del porqué los materiales empleados: las ejecuciones tácticas, medios, materiales, testigos de las actividades llevadas a cabo. <br>En este apartado lo que se valora no es la descripción que escribas en el resumen ejecutivo, sino la muestra en sí (que será un archivo ZIP independiente, el cual podrás cargar mas abajo).',
                            'medicion': '<strong>Medición/evaluación de resultados</strong> <br>En esta división, este es por supuesto el aspecto más relevante. ¿Qué se evaluó, cómo y con qué resultados? ¿El proyecto medido tuvo éxito o no? ¿Qué se hizo con los resultados? <br>En este caso, la medición no tiene porqué demostrar resultados exitosos, sino una metodología sólida de análisis ya sea cuantitativa o cualitativa (o una mezcla de metodologías) y debe estar relacionada con los objetivos a evaluar.',
                        }
                    }
                },
                counter: {
                    ['@change']() {
                        this.update();
                    },
                    ['@keydown']() {
                        this.update();
                    },
                    ['@keypress']() {
                        this.update();
                    },
                    ['@keyup']() {
                        this.update();
                    },
                    ['@blur']() {
                        this.update();
                    },
                    ['@focus']() {
                        this.update();
                    }
                },
                init() {
                    // const form = this.$el;

                    // if ( this.supportsLocalStorage() ) {
                    //     // Auto-save interval
                    //     setInterval(() => {
                    //         this.save();
                    //     }, 3000);
                    //     // Instantly save the form fields when the user leaves the page.
                    //     $(window).on('beforeunload', () => {
                    //         this.save();
                    //     });
                    //     // Clear on form submission
                    //     $(form).on('submit', () => {
                    //         this.clear();
                    //     });
                    //     // Try to load an auto-saved copy, if any
                    //     this.load();
                    // }

                    this.fill();
                    this.update();
                },
                clear() {
                    const hash = md5(window.location);
                    localStorage.removeItem(hash);
                },
                load() {
                    const form = this.$el;
                    const hash = md5(window.location);
                    const data = localStorage.getItem(hash);
                    const payload = JSON.parse(data);
                    if (payload) {
                        // Check if the fields are empty on the form
                        let empty = true;
                        Object.keys(payload.fields).forEach((key) => {
                            const field = $(`[name="${key}"]`);
                            if ( field.val() ) {
                                empty = false;
                            }
                        });
                        if (empty) {
                            $.alert('Se encontró una copia de guardado automático, ¿qué desea hacer?', {
                                buttons: {
                                    close: 'Continuar editando',
                                    cancel: 'Eliminar'
                                },
                                callbacks: {
                                    createButton: (button, text, name) => {
                                        switch (name) {
                                            case 'cancel':
                                                button.removeClass('btn-primary').addClass('btn-outline-primary');
                                            break;
                                        }
                                        button.text(text);
                                    },
                                    buttonClose: () => {
                                        Object.keys(payload.fields).forEach((key) => {
                                            const field = $(`[name="${key}"]`);
                                            field.val( payload.fields[key] );
                                            if (key == 'division') {
                                                this.fill();
                                            }
                                        });
                                        this.update();
                                        $.alert.api.close();
                                    },
                                    buttonCancel: () => {
                                        this.clear();
                                        $.alert.api.close();
                                    }
                                }
                            });
                        }
                    }
                },
                save() {
                    const form = this.$el;
                    const fields = $(form).find('input, textarea, select');
                    const payload = {
                        fields: {},
                        lastSaved: Date.now()
                    };
                    fields.each((index, el) => {
                        const $el = $(el);
                        const val = $el.val();
                        const name = $el.attr('name');
                        if (name.indexOf('_') !== 0 && val) {
                            payload.fields[name] = val;
                        }
                    });
                    if ( Object.keys(payload.fields).length > 0 ) {
                        const hash = md5(window.location);
                        localStorage.setItem(hash, JSON.stringify(payload));
                    }
                },
                update() {
                    const fields = $('[data-counter=words]');
                    let value = '';
                    fields.each((index, el) => {
                        const val = $(el).val();
                        value += (val ? ' ' + val : '');
                    });
                    this.words = this.countWords(value);
                    if (this.words < 2000) {
                        this.color = 'text-success';
                        this.icon = 'fa-solid fa-circle-check me-1';
                    } else {
                        this.color = 'text-danger';
                        this.icon = 'fa-solid fa-circle-exclamation me-1';
                    }
                },
                fill() {
                    const division = $(this.$refs.division).val();
                    const categoria = $(this.$refs.categoria);
                    const fields = $(this.$refs.fields);
                    const placeholder = categoria.data('placeholder');
                    const option = this.options[division] || null;
                    const prev = categoria.val();
                    categoria.prop('disabled', true);
                    categoria.empty();
                    categoria.append(`<option value="">${placeholder}</option>`)
                    if (option) {
                        option.items.forEach((item) => {
                            categoria.append(`<option value="${item}">${item}</option>`)
                        });
                        categoria.prop('disabled', false);
                        categoria.val( prev );
                        const labels = ['necesidad', 'publicos_objetivo', 'meta_general', 'meta_especifica', 'vision', 'muestra', 'medicion'];
                        labels.forEach((label) => {
                            $(`[for=${label}]`).html( option.labels[label] );
                        });
                        fields.removeClass('d-none');
                    } else {
                        fields.addClass('d-none');
                    }
                },
                supportsLocalStorage() {
                    try {
                        localStorage.setItem('localStorage-avaliable-test', null);
                    } catch {
                        return false;
                    }
                    if (typeof(Storage) === 'undefined') {
                        return false;
                    }
                    return true;
                },
                countWords(s) {
                    s = s.replace(/(^\s*)|(\s*$)/gi, '');// Exclude  start and end white-space
                    s = s.replace(/[ ]{2,}/gi, ' ');     // 2 or more space to 1
                    s = s.replace(/\n /, '\n');          // Exclude newline with a start spacing
                    return s.split(' ').filter((str) => { return str != ''; }).length;
                }
            }));

            Alpine.data('bulk', () => ({
                checkboxes: null,
                init() {
                    this.checkboxes = $(this.$el).find('input[type=checkbox]:not(:disabled)');
                },
                toggle() {
                    this.checkboxes.prop('checked', !this.checkboxes.prop('checked'));
                }
            }));

            Alpine.data('utils', () => ({
                goBack() {
                    history.back();
                },
                copy() {
                    const content = this.$el.dataset.content || null;
                    const icon = this.$el.querySelector('i');
                    const className = icon.className;
                    if (content) {
                        try {
                            navigator.clipboard.writeText(content);
                            icon.className = 'fa-regular fa-fw fa-circle-check';
                            setTimeout(() => {
                                icon.className = className;
                            }, 500)
                        } catch (err) {
                            //
                        }
                    }
                },
                unmask() {
                    const content = this.$el.dataset.content || null;
                    const icon = this.$el.querySelector('i');
                    const className = icon.className;
                    const target = $(this.$el.dataset.target);
                    if (content && target.length) {
                        icon.className = 'fa-solid fa-fw fa-unlock opacity-25';
                        target.text(content);
                    }
                },
                reveal() {
                    const className = this.$el.className;
                    const target = $(this.$el.dataset.target);
                    if (target.length) {
                        switch( target.attr('type') ) {
                            case 'password':
                                this.$el.className = 'fa-solid fa-unlock opacity-50';
                                target.attr('type', 'text');
                            break;
                            case 'text':
                                this.$el.className = 'fa-solid fa-lock opacity-25';
                                target.attr('type', 'password');
                            break;
                        }
                    }
                },
            }));

            Alpine.data('mobile', () => ({
                menu: null,
                button: null,
                init() {
                    if (! this.menu ) {
                        this.menu = document.querySelector('.menu-mobile');
                    }
                    if (! this.button ) {
                        this.button = document.querySelector('.btn-mobile');
                    }
                },
                openMenu() {
                    this.menu.classList.add('is-open');
                    this.button.classList.add('is-active');
                },
                closeMenu() {
                    this.menu.classList.remove('is-open');
                    this.button.classList.remove('is-active');
                },
                toggleMenu() {
                    this.menu.classList.toggle('is-open');
                    this.button.classList.toggle('is-active');
                }
            }));
        });
    }

    onDomReady($) {
        moment.locale('es');

        $('.mfp-image').magnificPopup();
        $('.mfp-video').magnificPopup({
            type: 'iframe'
        });

        $('[data-select=date]').each(function() {
            var input = $(this);
            input.attr('autocomplete', 'off');
            input.on('click', function() {
                var val = input.val();
                var date = val ? $.datePicker.defaults.dateParse(val) : null;
                var widget = $.datePicker.api.show({
                    views: {
                        month: {
                            show: val ? date : '',
                            selected: val ? [ date ] : []
                        }
                    },
                    element: input
                });
                input.data('widget', widget);
            });
        });

        $('.js-circle-progress').each(function() {
            var el = $(this),
                fill = el.data('color') || '#FF0000',
                value = el.data('count') || 0;
            el.circleProgress({
                value: value,
                size: 320,
                fill: fill
            });
        });

        $('.js-chart').each(function() {
            var el = $(this),
                canvas = document.getElementById( el.data('canvas') ),
                config = $.parseJSON( el.val() );
            config.options.plugins.tooltip = {
                callbacks: {
                    title: (context) => {
                        let label = context[0].label || '';
                        label = label.replace(', 12:00:00 am', '');
                        return label[0].toUpperCase() + label.slice(1);;
                    }
                }
            };
            config.options.scales.x.ticks = {
                callback: (value) => value[0].toUpperCase() + value.slice(1)
            };
            var chart = new Chart(canvas.getContext('2d'), config);
            el.data('chart', chart);
        });
    }
}

window.app = window.app || new App();
